import { ShareIcon } from "@heroicons/react/20/solid";
import React from "react";

export const sharedChipClassName =
    "inline-flex items-center gap-1 rounded-full bg-brand-200 px-2 py-0.5 text-xs font-bold text-brand-700";

export const SharedChipContent: React.FC<{ label: string }> = ({ label }) => (
    <>
        <ShareIcon className="h-4 w-4" aria-hidden="true" />
        <span className="hidden md:inline">{label}</span>
    </>
);

export const SharedChip: React.FC<{ label: string }> = ({ label }) => (
    <span className={sharedChipClassName} title={label}>
        <SharedChipContent label={label} />
    </span>
);
